import React from "react";
import { statusTypes } from "../../../mls-match-list/utils";
import { AppleTVIcon } from "../../svg/AppleTVIcon/AppleTVIcon";
import { AppleTVPlusIcon } from "../../svg/AppleTVPlusIcon/AppleTVPlusIcon";
import { AppleTVSeasonPass } from "../../svg/AppleTVSeasonPass/AppleTVSeasonPass";
import { RightArrowIcon } from "../../svg/RightArrowIcon/RightArrowIcon";
import { appleTvTypes } from "../../utils";
import { Link } from "../Link/Link";
import { StyledAppleMatchBroadcaster } from "./StyledAppleMatchBroadcaster";

const AppleMatchBroadcaster = ({ status, broadcaster, url, matchPageUrl }) => {
  const AppleTvIconComponent = () => {
    switch (broadcaster) {
      case appleTvTypes.appleTv:
        return (
          <AppleTVIcon
            width={21}
            height={10}
            opacity={status?.abbreviation === statusTypes.live ? 1 : 0.4}
          />
        );
      case appleTvTypes.appleTvPlus:
        return (
          <AppleTVPlusIcon
            width={27}
            height={10}
            opacity={status?.abbreviation === statusTypes.live ? 1 : 0.4}
          />
        );
      case appleTvTypes.appleTvSeasonPass:
        return (
          <AppleTVSeasonPass
            width={40}
            height={15}
            opacity={status?.abbreviation === statusTypes.live ? 1 : 0.4}
          />
        );
      default:
        return <RightArrowIcon width={5} height={10} />;
    }
  };

  return (
    <StyledAppleMatchBroadcaster>
      {status?.abbreviation === statusTypes.live ||
      status?.abbreviation === statusTypes.pre ||
      status?.abbreviation === statusTypes.postponed ? (
        url ? (
          <Link url={url} target="_blank">
            <AppleTvIconComponent />
          </Link>
        ) : (
          <AppleTvIconComponent />
        )
      ) : (
        <Link url={matchPageUrl} target="_blank">
          <RightArrowIcon width={5} height={10} />
        </Link>
      )}
    </StyledAppleMatchBroadcaster>
  );
};

export default AppleMatchBroadcaster;
